import { BrowserRouter, Routes, Route } from 'react-router-dom'
import styled, { createGlobalStyle } from 'styled-components'
import reset from 'styled-reset'
import UserContext from '../context/UserContext'
import { useState } from 'react'

import Home from './Home'
import InstrucaoCalibragem from './InstrucaoCalibragem'
import Explicacao from './Explicacao'
import Calibragem from './Calibragem'
import ComAnel from './ComAnel'
import InstrucaoSemAnel from './InstrucaoSemAnel'
import SemAnel from './SemAnel'

import wallpaper from '../imgs/wallpaper/wallpaper.jpg'

export default function App() {
  const [tamCartao, setTamCartao] = useState('160')
  const umCm = tamCartao / 5.4

  return (
    <>
      {/* <Img1 src={wallpaper}></Img1> */}
      <BrowserRouter>
        <GlobalStyled />
        <UserContext.Provider value={{ tamCartao, setTamCartao, umCm }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/instrucao-calibragem"
              element={<InstrucaoCalibragem />}
            />
            <Route path="/explicacao" element={<Explicacao />} />
            <Route path="/calibragem" element={<Calibragem />} />
            <Route path="/medicao-com-anel" element={<ComAnel />} />

            <Route path="/instrucao-sem-anel" element={<InstrucaoSemAnel />} />
            <Route path="/medicao-sem-anel" element={<SemAnel />} />
          </Routes>
        </UserContext.Provider>
      </BrowserRouter>
    </>
  )
}

const GlobalStyled = createGlobalStyle`
    ${reset}
    *, body {
        box-sizing: border-box;
        cursor: default;
        font-family: 'Montserrat', sans-serif;
        color: #1A1A1A;
    a {
        text-decoration: none;
    }
    };

    body {
      background-color: rgba(102, 176, 180, 0.1);
    }
`

const Img1 = styled.img`
  position: fixed;
  top: 0;
  height: 100vh;
  min-width: 100vw;
  z-index: -1;
  opacity: 1;

  @media (min-width: 700px) {
    transform: rotate(0);
    min-height: 100vh;
    width: auto;
  }

  @media (min-width: 1300px) {
    height: auto;
    width: 100vw;
  }
`
// .color1 { #0d9ca9 };
// .color2 { #5eb7c7 };
// .color3 { #642c1c };
// .color4 { #9a7373 };
// .color5 { #b59fa5 };

// azul = #66B0B4
// marrom = #d9bf9c
